import React, { useEffect, useState } from 'react';
import { Page, PDFViewer, PDFDownloadLink, Text, View, Document, StyleSheet, Image, Font, } from '@react-pdf/renderer';



import numero from 'numero-por-extenso';
 
import { useParams } from 'react-router-dom';
import api from 'src/services/api';
import { fullDate } from 'src/utils/date';
import { useConfiguration } from 'src/hooks/Configuration';
import { loadFromJson } from 'src/utils/loadFromJson';
 import { hash as hashApp } from 'src/config';

Font.register({
  family: 'Montserrat',
  fonts: [
    { src: '/assets/fonts/Montserrat-Regular.ttf' },
    { src: '/assets/fonts/Montserrat-Bold.ttf', fontStyle: 'bold' }
  ]

});


interface IProps {
  hash?: string;
}

interface IRecibo {
  name: string;
  document_number: string;
  sale_hash: string;
  total: number;
  payment_date: Date;
  createdAt: Date;
  projeto: string;
  payer_type: string;
  product: string;
  razao_social: string;
    cnpj: string;
}

export const Recibo: React.FC<IProps> = () => {
  const {} = useConfiguration();
  const [recibo, setRecibo] = useState<IRecibo>({} as IRecibo);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [free, setFree] = useState(false);
  const [notPaid, setNotPaid] = useState(false);
  const { hash, projectHash } = useParams<Record<string, any>>();


  const load = async () => {

      let data: Record<string, any> = {};
    
        const item = await loadFromJson({ hash: hashApp, project_id: 'global', table: 'Global' });
        const config = item?.[0];

    const response = await api.get(`/recibo/${projectHash}/${hash}`);
    

    const { status } = response.data;

    if (status === 'failed') {
      setFailed(true);
      return;
    }
    if (status === 'notPaid') {
      setNotPaid(true);
      return;
    }

    if (status === 'free' || response?.data?.recibo?.total <= 0) {
      setFree(true);
      return;
    }

    const reciboInfo = response?.data?.recibo || {};
reciboInfo.razao_social = config?.company_name;
    reciboInfo.cnpj = config?.company_document;

    if (status === 'ready') {
      setLoading(false);
      setRecibo(reciboInfo);
      setReady(true);
    }

  }

  useEffect(() => {
    load();
  }, [])

  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#fff",
      color: "#333",
      padding: '20px'
    },
    section: {
      margin: 10,
      padding: 10,
    },
    viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
    },
  });

  if (notPaid) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h2>O pagamento não foi identificado</h2><br /><br />
      <p style={{ textAlign: 'center' }}> <strong>Protocolo da compra:</strong><br /> {hash}</p>
    </div >
  }

  if (failed) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
      <h2>Compra não identificada.</h2><br /><br />
      <p style={{ textAlign: 'center' }}><strong>Protocolo da compra:</strong> <br />{hash}</p>
    </div >
  }
  if (free) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>

      <h2>Comprovante de pagamento não é emitido para cortesias.</h2><br />

    </div >
  }


  if (loading) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <h2>Verificando...</h2>
    </div >
  }

  if (ready) {
    return <>
      <PDFDownloadLink fileName='recibo.pdf' document={
        <Document >
          {/*render a single page*/}
          <Page size="A4" style={styles.page}>

            <View>  <Image style={{ width: '150px' }} src="/apoio/logo-padrao.png" />
            </View>

            <View style={{ borderTop: '1px solid #000', marginTop: '15px', paddingTop: '20px' }}>
              <Text style={{ fontWeight: 'bold', fontSize: '24px', margin: '30px auto', textAlign: 'center', width: '100%' }}>RECIBO</Text>
              <Text style={{ fontWeight: 700, fontSize: '10px', textAlign: 'center', marginBottom: '30px', width: '100%' }}>Chave de controle: {recibo.sale_hash}</Text>
            </View>


            <View style={styles.section}>
              <Text style={{ fontSize: '14px' }}>{`A ${recibo?.razao_social}, CNPJ ${recibo?.cnpj}, recebeu de ${recibo.name} inscrito no ${recibo?.payer_type === 'cnpj' ? 'CNPJ' : 'CPF'} nº ${recibo.document_number}, a quantia de R$ ${(recibo.total / 100).toFixed(2).replace('.', ',')} (${numero.porExtenso(recibo.total / 100, numero.estilo.monetario)}) referente ao pagamento de inscrição no evento ${recibo.projeto}.`}</Text>
            </View>
            <View style={{ width: '100%', textAlign: 'right', fontSize: '14px', marginTop: '60px' }}>
              <Text>Porto Alegre, {fullDate(recibo.payment_date || recibo?.createdAt)}</Text>
            </View>



          </Page>
        </Document>


      }>
        <button className='defaultButton'> Realizar Download do recibo </button>
      </PDFDownloadLink>


      <aside className='computerOnly' style={{ width: '100%' }}>
        <PDFViewer style={{
          width: window.innerWidth, //the pdf viewer will take up all of the width and height
          height: window.innerHeight,
        }}>
          <Document >
            {/*render a single page*/}
            <Page size="A4" style={styles.page}>

              <View>  <Image style={{ width: '150px' }} src="/apoio/logo-padrao.png" />
              </View>

              <View style={{ borderTop: '1px solid #000', marginTop: '15px', paddingTop: '20px' }}>
                <Text style={{ fontWeight: 'bold', fontSize: '24px', margin: '30px auto', textAlign: 'center', width: '100%' }}>RECIBO</Text>
                <Text style={{ fontWeight: 700, fontSize: '10px', textAlign: 'center', marginBottom: '30px', width: '100%' }}>Chave de controle: {recibo.sale_hash}</Text>
              </View>


              <View style={styles.section}>
                <Text style={{ fontSize: '14px' }}>{`A ${recibo?.razao_social}, CNPJ ${recibo?.cnpj}, recebeu de ${recibo.name} inscrito no ${recibo?.payer_type === 'cnpj' ? 'CNPJ' : 'CPF'} nº ${recibo.document_number}, a quantia de R$ ${(recibo.total / 100).toFixed(2).replace('.', ',')} (${numero.porExtenso(recibo.total / 100, numero.estilo.monetario)}) referente ao pagamento de inscrição na modalidade ${recibo.product} do projeto ${recibo.projeto}.`}</Text>
              </View>
              <View style={{ width: '100%', textAlign: 'right', fontSize: '14px', marginTop: '60px' }}>
                <Text>Porto Alegre, {fullDate(recibo?.payment_date || recibo?.createdAt)}</Text>
              </View>


            </Page>
          </Document>
        </PDFViewer>
      </aside>
    </>
  }

  return <></>
}